// RU-SCANPERF SP-9: registers the router's navigate for lib/navBridge (rendered once, inside the router).
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { setNavigator } from "@/lib/navBridge";

export default function NavBridge() {
  const navigate = useNavigate();
  useEffect(() => {
    setNavigator(navigate);
    return () => setNavigator(null);
  }, [navigate]);
  return null;
}
